export class SortObject {
  currentSortField: string;
  currentOrderIsDescending: boolean;
}
